module.exports = __webpack_public_path__ + "img/basic-info.5ec30a64.png";